import React, { Component } from 'react';
import * as KJUR from 'jsrsasign';  // Import the KJUR object
import logo from '../assets/logo.png';  // Importing the logo
import logo2 from '../assets/logo2.png';
import './CSS/SecretPage.css';  // Assuming you have a CSS file for styling

class Rs256Signature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      incompleteToken: '',  // The input for header and payload without signature
      privateKey: '',       // The private key for signing
      completeJwt: '',      // The fully signed JWT
      error: '',            // For error messages
      copied: false,        // State to track if the token was copied
    };
  }

  // Function to generate a complete JWT
  generateCompleteJWT = () => {
    try {
      const { incompleteToken, privateKey } = this.state;

      // Clear previous errors and reset copy status
      this.setState({ error: '', completeJwt: '', copied: false });

      console.log("Incomplete token:", incompleteToken);
      console.log("Private key:", privateKey);

      // Split the incomplete token into its parts (header and payload)
      const tokenParts = incompleteToken.split('.');

      if (tokenParts.length !== 2) {
        throw new Error('Incomplete token. Please ensure you are providing only the header and payload, separated by a dot (header.payload).');
      }

      const [headerBase64, payloadBase64] = tokenParts;

      // Base64 decode the header and payload safely
      const sHeader = KJUR.jws.JWS.readSafeJSONString(atob(headerBase64));
      const sPayload = KJUR.jws.JWS.readSafeJSONString(atob(payloadBase64));

      if (!sHeader || !sPayload) {
        throw new Error('Failed to decode header or payload.');
      }

      console.log("Decoded Header:", sHeader);
      console.log("Decoded Payload:", sPayload);

      // Re-sign the token using the private key and RS256 algorithm
      const signedJwt = KJUR.jws.JWS.sign(
        "RS256",
        JSON.stringify(sHeader),
        JSON.stringify(sPayload),
        privateKey
      );

      // Set the complete signed JWT in the state
      this.setState({ completeJwt: signedJwt });
      console.log("Complete JWT:", signedJwt);

    } catch (err) {
      console.error('Error generating complete JWT:', err);
      this.setState({ error: err.message });
    }
  };

  // Function to copy the token to clipboard
  copyToClipboard = () => {
    if (this.state.completeJwt) {
      navigator.clipboard.writeText(this.state.completeJwt)
        .then(() => {
          this.setState({ copied: true });
        })
        .catch(err => {
          console.error('Failed to copy the token: ', err);
        });
    }
  };

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  render() {
    return (
      <div className="container mt-4 text-center">
        {/* Add your logos */}
        <img className='logo mb-4' src={logo} alt="Logo" />  {/* Main logo at the top */}

        <h2>Complete JWT Generator</h2>

        <div className="form-group mt-4">
          <label>Incomplete Token (Header + Payload, no signature)</label>
          <textarea
            className="form-control"
            rows="3"
            name="incompleteToken"
            value={this.state.incompleteToken}
            onChange={this.handleInputChange}
            placeholder="Enter incomplete token (header.payload)"
          ></textarea>
        </div>

        <div className="form-group mt-4">
          <label>Private Key</label>
          <textarea
            className="form-control"
            rows="6"
            name="privateKey"
            value={this.state.privateKey}
            onChange={this.handleInputChange}
            placeholder="Paste your private key here"
          ></textarea>
        </div>

        <button className="btn btn-primary mt-3" onClick={this.generateCompleteJWT}>
          Generate Complete JWT
        </button>

        {this.state.completeJwt && (
          <>
            <div className="form-group mt-4">
              <label>Complete Signed JWT</label>
              <textarea
                className="form-control"
                rows="6"
                readOnly
                value={this.state.completeJwt}
              ></textarea>
            </div>

            {/* Copy Token Button */}
            <button className="btn btn-secondary mt-2" onClick={this.copyToClipboard}>
              Copy Token
            </button>
            {this.state.copied && <span className="ml-2 text-success">Token copied!</span>}
          </>
        )}

        {this.state.error && (
          <div className="alert alert-danger mt-4">
            <strong>Error:</strong> {this.state.error}
          </div>
        )}

        <div className="text-center mt-5">
          <div>Powered by</div>
          <img className='logo2' src={logo2} alt="Logo 2" />  {/* Third logo */}
        </div>
      </div>
    );
  }
}

export default Rs256Signature;
